import HealthPlanRepository from '@/shared/http/repositories/socialProject/health-plan'
import { loading, toast } from '@/shared/utils/UIHelper'
import { IsSuccessCode } from '@/shared/utils/API'
import * as mutation from './mutationTypes'
import { actionTypes as action } from './actionTypes'

export const actions = {
  [action.FETCH_HEALTH_PLANS]: async ({ commit }) => {
    try {
      loading.push()

      const res = await HealthPlanRepository.GetAll()
      if (!IsSuccessCode(res)) return Promise.reject()

      commit(mutation.SET_HEALTH_PLANS, res.data.data)
      loading.pop()
      return Promise.resolve()
    } catch (error) {
      loading.pop()
      toast.error('Erro ao carregar planos de saúde', 'ERRO')
    }
  }
}
